export const vatList = [
    { id: 6, name: 'VAT 0%'},
    { id: 5, name: 'VAT 5%' }
];

export const status =[
    { id: 2, name: 'Active'},
    { id: 3, name: 'Inactive' }
]
export  const termsTypeList = [
    { id: 1, name: "Purchase Orders" },
    { id: 2, name: "Invoices" },
  ];

export const units = [
    { id: 1, name: 'QTY%' },
    { id: 2, name: 'Sq.ft' },
    { id: 3, name: 'Ltr' },
    { id: 4, name: 'Kgs' },
    { id: 5, name: 'Box' },
    { id: 6, name: 'Bags' },
    { id: 7, name: 'Pcs' },
    { id: 8, name: 'Cu.ft' },
    { id: 9, name: 'NOS' },
    { id: 10, name: 'RFT' },
    { id: 11, name: 'Length' },
    { id: 12, name: 'Coils' },
    { id: 13, name: 'Roll' },
    { id: 14, name: 'Sq.mt' },
    { id: 15, name: 'Cu.mt' },
    { id: 16, name: 'RMT' },
    { id: 17, name: 'cft' }
   ];
export const storeType = [
    { id: 1, name: "store" },
    { id: 2, name: "warehouse" },
    { id: 3, name: "sales Person" },
  ];
// NOTE: "Others" is intentionally NOT in this list — CDN/Invoice/Customer
// forms each add it as their own MenuItem alongside a free-text field, since
// "Others" isn't a real emirate value to save, just a UI trigger.
export const emirates = [
    { id:1, name: 'Abu Dhabi' },
    { id:2, name: 'Dubai' },
    { id:3, name: 'Sharjah' },
    { id:4, name: 'Ajman' },
    { id:5, name: 'Umm Al Quwain' },
    { id:6, name: 'Ras Al Khaimah' },
    { id:7, name: 'Fujairah' },
];

export const isKnownEmirate = (value) =>
  emirates.some(
    (e) => e.name.toLowerCase() === String(value || "").toLowerCase()
  );